export const COMPANY_SEARCH_TAG_NAME = 'tm-bo-company-search-container';
export const INSTITUTION_SEARCH_TAG_NAME = 'tm-bo-institution-search';
export const USER_SEARCH_TAG_NAME = 'tm-bo-user-search';
